@import './pk-divider.variables';

:host(.divider) {
  @apply inline-block w-[var(--divider-width)] border-0 border-t-[length:var(--divider-border-width)] border-solid border-t-[color:var(--divider-color)];
}

:host(.divider--vertical) {
  @apply h-[var(--divider-height)] w-[var(--divider-border-width)] border-0 border-l-[length:var(--divider-border-width)] border-t-0 border-solid border-l-[color:var(--divider-color)] align-middle;
}
